import { render, staticRenderFns } from "./ordenesMedicamentoUrgencia.vue?vue&type=template&id=6f81e35f&"
import script from "./ordenesMedicamentoUrgencia.vue?vue&type=script&lang=js&"
export * from "./ordenesMedicamentoUrgencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports